import { render, staticRenderFns } from "./Planeador.vue?vue&type=template&id=72433180&"
import script from "./Planeador.vue?vue&type=script&lang=js&"
export * from "./Planeador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports